import { render, staticRenderFns } from "./UserListView.vue?vue&type=template&id=35eda188&scoped=true"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"
import style0 from "./UserListView.vue?vue&type=style&index=0&id=35eda188&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eda188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35eda188')) {
      api.createRecord('35eda188', component.options)
    } else {
      api.reload('35eda188', component.options)
    }
    module.hot.accept("./UserListView.vue?vue&type=template&id=35eda188&scoped=true", function () {
      api.rerender('35eda188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserListView.vue"
export default component.exports